export const getUsersImagePath = (photoUrl?: string) => {
  if (!photoUrl) return '/static/user/default.svg';
  return `https://worknity-users.s3.us-west-1.amazonaws.com/${photoUrl}`;
};

export const getAvatarImagePath = (photoUrl?: string) => {
  if (!photoUrl) return '';
  return `https://worknity-users.s3.us-west-1.amazonaws.com/${photoUrl}`;
};

export const getPathwaysImagePath = (photoUrl: string) => {
  if (!photoUrl) {
    return '/static/pathway/default.svg';
  }
  return `https://worknity-pathways.s3.us-west-1.amazonaws.com/${photoUrl}`;
};
